import * as types from '../mutation-types'

import awards from '@/api/awards'
const state = {
  awards: [],
  ssdAwards: [],
  ssdScholarships: []
}

const getters = {
  awards: (state) => {
    return state.awards
  },
  ssdAwards: (state) => {
    return state.ssdAwards
  },
  ssdScholarships: (state) => {
    return state.ssdScholarships
  }
}

// actions
const actions = {
  getAwards ({ commit, state }, { siteSource, limit, offset, siteVisibility }) {
    commit(types.CLEAR_AWARDS)
    return new Promise((resolve, reject) => {
      awards.get(siteSource, limit, offset, siteVisibility).then((response) => {
        const awards = response.data.result.awards
        awards.forEach((award) => {
          if (!['OhioSSDAwards', 'OhioSSDScholarship'].includes(siteVisibility)) {
            commit(types.ADD_AWARD, award)
          } else {
            commit(types.ADD_SSD_AWARD, { award, siteVisibility })
          }
        })
        resolve()
      }, (error) => {
        reject(error)
      })
    })
  },
  getAwardByEvent ({ commit, rootGetters }) {
    const currentPage = rootGetters.currentPage
    const fairId = rootGetters.currentFair(currentPage)?.id ?? 0
    return new Promise((resolve, reject) => {
      awards.getAwardByEvent(fairId).then((response) => {
        resolve(response.data.result.awards)
      }, (error) => {
        reject(error)
      })
    })
  },
  createAward ({ commit }, data) {
    return new Promise((resolve, reject) => {
      awards.create(data).then((response) => {
        const award = response.data.result.award
        commit(types.ADD_AWARD, award)
        resolve(award)
      }, (error) => {
        reject(error)
      })
    })
  },
  giveProjectAward ({ commit }, { projectID, awardID }) {
    return new Promise((resolve, reject) => {
      awards.giveProjectAward(projectID, awardID).then((response) => {
        const project = response.data.result.project
        commit(types.ADD_PROJECT, project)
        resolve(project)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateAward ({ commit }, { awardID, data }) {
    return new Promise((resolve, reject) => {
      awards.update(awardID, data).then((response) => {
        const award = response.data.result.award
        resolve(award)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteAward ({ commit }, awardID) {
    return new Promise((resolve, reject) => {
      awards.delete(awardID).then(() => {
        resolve()
      }, (error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.ADD_AWARD] (state, award) {
    state.awards.push(award)
  },
  [types.ADD_SSD_AWARD] (state, params) {
    if (params.siteVisibility === 'OhioSSDAwards') {
      state.ssdAwards.push(params.award)
    } else {
      state.ssdScholarships.push(params.award)
    }
  },
  [types.CLEAR_AWARDS] (state, award) {
    state.awards = []
    state.ssdAwards = []
    state.ssdScholarships = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
